import React, {useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';

import {CART_CTA} from 'constants/analytics/events/cart';

import {PaymentsButtonsConnected} from '../paymentsButtons/paymentsButtons';

import s from './cartSummaryButtons.scss';

export type PropsType = {
    isZeroTotal: boolean;
    itemsCount: number;
    goToCheckout: () => void;
    loadingButton: boolean;
    disablePaymentButtons?: boolean;
    hasOutOfStock?: boolean;
};

/**
 * Displays summary block buttons
 * @param {PropsType} props - component props
 * @return {React.ReactElement} block with CTA button
 */
export const CartSummaryButtons: React.FC<PropsType> = ({
    disablePaymentButtons = false,
    goToCheckout,
    hasOutOfStock,
    isZeroTotal,
    itemsCount,
    loadingButton,
}) => {
    const buttonText = 'Proceed to Checkout';
    const onClick = useCallback(() => {
        sendDesktopAnalyticsEvent(CART_CTA, {
            action: 'Right Section',
            label: buttonText,
        });
        goToCheckout();
    }, [goToCheckout]);

    const isPaymentButtons = !isZeroTotal && !disablePaymentButtons;

    return (
        <>
            <div className={s.wrapper} data-test-name="proceedToCheckoutBtn">
                <CtaButton
                    className={s.btnTextV2}
                    isDisabled={Boolean(itemsCount === 0) || hasOutOfStock}
                    isLoading={loadingButton}
                    onClick={onClick}
                    size="medium"
                    isFull
                >
                    {buttonText}
                </CtaButton>
            </div>
            {isPaymentButtons && (
                <>
                    <p className={s.fastCheckoutLine}>Fast checkout with</p>
                    <PaymentsButtonsConnected />
                </>
            )}
        </>
    );
};

CartSummaryButtons.displayName = 'CartSummaryButtons';
